import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: 'InfoAlert'
})
export default class InfoAlert extends Vue {
    @Prop({ required: true })
    message!: string;
}